import React from 'react';
import { Heading, Box, ThemeUIStyleObject, Text } from 'theme-ui';
type Props = {
  heading: string | null;
  subheading: string | null;
  headingMobile?: string | null;
  subheadingMobile?: string | null;
  forwardSx?: ThemeUIStyleObject;
};
const ModalHeadings = ({ heading, subheading, headingMobile, subheadingMobile, forwardSx }: Props) => {
  const hasMobileHeadings = !!headingMobile || !!subheadingMobile;

  return (
    <Box sx={{ px: '2.4rem', pt: '3.2rem', ...forwardSx }}>
      <Box sx={{ display: [hasMobileHeadings ? 'none' : 'grid', 'grid'] }}>
        <Text
          sx={{
            fontSize: '1.8rem',
            lineHeight: [1, 0.9],
            fontWeight: 'bold',
            textTransform: 'uppercase',
            mb: ['0.8rem', '1.6rem'],
          }}
          dangerouslySetInnerHTML={{ __html: subheading ?? '' }}
        />

        <Heading
          as="h4"
          sx={{
            variant: 'text.heading',
            textTransform: 'uppercase',
          }}
          dangerouslySetInnerHTML={{ __html: heading ?? '' }}
        />
      </Box>
      {hasMobileHeadings && (
        <Box sx={{ display: ['grid', 'none'] }}>
          {subheadingMobile ? (
            <Text
              sx={{
                fontSize: '1.8rem',
                lineHeight: [1, 0.9],
                fontWeight: 'bold',
                textTransform: 'uppercase',
                mb: '0.8rem',
              }}
              dangerouslySetInnerHTML={{ __html: subheadingMobile }}
            />
          ) : null}
          {headingMobile ? (
            <Heading
              as="h4"
              sx={{
                variant: 'text.heading',
                textTransform: 'uppercase',
              }}
              dangerouslySetInnerHTML={{ __html: headingMobile }}
            />
          ) : null}
        </Box>
      )}
    </Box>
  );
};

export default ModalHeadings;
